//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DetailsContentCard',
  props: {
    title: { type: [String, Number], default: '' },
    content: { type: [String, Number], default: '' },
    noLine: { type: Boolean, default: false },
    sub: { type: Boolean, default: false },
    info: { type: Boolean, default: false },
    wrap: { type: Boolean, default: true },
  },
  computed: {
    hasSlots() {
      return !!this.$slots.default;
    },
    hasContent() {
      return this.hasSlots || this.content !== '';
    },
  },
};
